export default __webpack_public_path__ + "locales/pl/ConvertPasswordDialog.json?hash=bd959bcac07efe50158aa5047fafd345";